
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ijr76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
var $d54f08879f801abc$var$scrollToElement = function scrollToElement(element) {
    var target = document.querySelector(element);
    var targetOffset = target.getBoundingClientRect().top;
    var headerHeight = document.querySelector("header").getBoundingClientRect().height;
    var scrollEl = targetOffset + window.scrollY - headerHeight - 10;
    $("html, body").stop().animate({
        scrollTop: scrollEl
    }, 400);
};
var $d54f08879f801abc$var$init = module.exports.init = function init() {
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        var donationForm = document.querySelector("#donation_form");
        if (++attempts > 30) return;
        if (donationForm) {
            var nextBtns = donationForm.querySelectorAll(".donation-form__btn-next");
            nextBtns.forEach(function(btn) {
                btn.addEventListener("click", function(e) {
                    if (window.innerWidth <= 992) {
                        e.preventDefault();
                        setTimeout(function() {
                            return $d54f08879f801abc$var$scrollToElement(btn.getAttribute("href"));
                        }, 100);
                    }
                });
            });
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=donations.module.a6a52ee1.js.map
